'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Hold on to a previous value in a React ref.
 * @param value T | null
 * @returns T | null
 */ const usePrevious = (value)=>{
    const ref = React.useRef(null);
    React.useEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

exports.usePrevious = usePrevious;
//# sourceMappingURL=use-previous.js.map
